import React, { useEffect, useState } from 'react';
import Loader from '../../layouts/loader';
import apiService from '../../../services/apiService';
import CustomToast from "../../Toast";
import '../../../custom.css';
const ViewUser = () => {
    const [viewUser, setViewUser] = useState([]);
    const [courseList, setCourseList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [orgCourseId, setOrgCourseId] = useState('');
    let orgId = JSON.parse(localStorage.getItem('orgInfo'));

    const showErrorToast = () => {
        CustomToast.info('It seems your connection is slow. Please refresh the page or try again in sometime.');
    };

    const fetchData = async (endpoint, token) => {
        try {
            return await apiService.get(endpoint, token);
        } catch (error) {
            console.error(error);
            showErrorToast();
        }
    };

    const getInitialData = async () => {
        setLoader(true);
        const token = apiService.getAuthToken();
        try {
            const courseListResponse = await fetchData(`get_org_course_list/${orgId.org_id}`, token);
            const courseList = courseListResponse?.data || [];
            const firstCourseId = courseList[0]?.org_course_id;
            if (!firstCourseId) {
                CustomToast.info('No course found for this organization.');
                setLoader(false);
                return;
            }
            const params = {
                org_id: orgId.org_id,
                org_course_id: firstCourseId
            };
            const query = new URLSearchParams(params).toString();
            const viewUserResponse = await fetchData(`get-user-test-result?${query}`, token);
            setCourseList(courseList);
            setViewUser(viewUserResponse?.data || []);
        } catch (err) {
            console.error(err);
            CustomToast.error('Failed to fetch view user data');
        } finally {
            setLoader(false);
        }
    };

    const handleCourseChange = async (e) => {
        const selectedCourseId = e.target.value;
        setOrgCourseId(selectedCourseId);

        const token = apiService.getAuthToken();
        const params = {
            org_id: orgId.org_id,
            org_course_id: selectedCourseId
        };
        const query = new URLSearchParams(params).toString();

        try {
            setLoader(true);
            const response = await fetchData(`get-user-test-result?${query}`, token);
            setViewUser(response?.data || []);
        } catch (err) {
            CustomToast.error('Failed to fetch filtered user data');
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo(0, 0);
        });
        getInitialData();
    }, []);

    return (
        <>
            {
                loader ? <Loader /> :
                    <div className='page__main'>
                        <div className="dashboard" style={{ minHeight: '100vh' }}>
                            <div className='container-fluid'>
                                <div className='mb-4'>
                                    <h3 className="fw-semibold font-26 mb-2">View Users</h3>
                                    <small>View the list of the employees in your organisation and track their status</small>
                                </div>
                                <div className="card shadow-sm p-4 mt-2">
                                    <div className='mb-4'>
                                        <p className="fw-bold">Select course</p>
                                        <select
                                            className="form-select"
                                            style={{ width: "330px", position: "relative" }}
                                            value={orgCourseId}
                                            onChange={handleCourseChange}
                                            defaultValue="Safe workplaces">
                                            {courseList.map(course => (
                                                <option key={course.org_course_id} value={course.org_course_id}>
                                                    {course.course_title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="styled-table">
                                            <thead>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Full Name</th>
                                                    <th>Course Status</th>
                                                    <th>Result</th>
                                                    <th>Baseline Score</th>
                                                    <th>Endline Score</th>
                                                    <th>Attempts</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {viewUser && viewUser.length > 0 ? (
                                                    viewUser.map((user, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{user.name || '-'}</td>
                                                            <td >{user.merged_status || '-'}</td>
                                                            <td
                                                                className={
                                                                    user.result === 'pass'
                                                                        ? 'text-success'
                                                                        : user.result === 'fail'
                                                                            ? 'text-danger'
                                                                            : user.result === 'pending'
                                                                                ? 'text-warning'
                                                                                : ''
                                                                }
                                                            >
                                                                {user.result || '-'}
                                                            </td>
                                                            <td>{user.base_line_test ?? '-'}</td>
                                                            <td>{user.end_line_test ?? '-'}</td>
                                                            <td>{user.attempts ?? '-'}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" className="text-center">No data available</td>
                                                    </tr>
                                                )}
                                            </tbody>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </>
    );
};
export default ViewUser;